import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const slides = [
    {
        img: 'img/rooms/03.jpg',
        sub: 'Nature-Inspired Luxury',
        title: ['Ready to Rock', 'Your Journey'],
        desc: 'Discover a boutique escape where nomadic spirit meets luxury — deep in the heart of nature.',
        cta: { label: 'Explore Rooms', to: '/rooms' },
    },
    {
        img: 'img/rooms/02.jpg',
        sub: 'Destination Spa',
        title: ['Restore and', 'Reconnect'],
        desc: 'Experience a destination spa where ancient Mongolian wisdom meets modern wellness.',
        cta: { label: 'Spa & Wellness', to: '/spa' },
    },
    {
        img: 'img/rooms/01.jpg',
        sub: 'Unforgettable Experiences',
        title: ['Your Story', 'Begins Here'],
        desc: 'From wild adventures to peaceful retreats — we create the moments you will never forget.',
        cta: { label: 'Our Experiences', to: '/experiences' },
    },
];

export default function Slider() {
    const [current, setCurrent] = useState(0);
    const [animKey, setAnimKey] = useState(0);

    const goTo = useCallback(function(idx) {
        setCurrent(idx);
        setAnimKey(function(k) { return k + 1; });
    }, []);

    const next = useCallback(function() {
        goTo((current + 1) % slides.length);
    }, [current, goTo]);

    useEffect(function() {
        const timer = setInterval(next, 6000);
        return function() { clearInterval(timer); };
    }, [next]);

    const slide = slides[current];

    return (
        <header className="sl-hero">

            {/* Background layers */}
            {slides.map(function(s, i) { return (
                <div
                    key={i}
                    className={`sl-bg${i === current ? ' sl-bg--active' : ''}`}
                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/${s.img})` }}
                />
            ); })}

            <div className="sl-overlay" />

            {/* Text content */}
            <div className="sl-content" key={animKey}>
                <div className="sl-sub">{slide.sub}</div>
                <h1 className="sl-title">
                    {slide.title.map(function(line, i) { return <span key={i}>{line}</span>; })}
                </h1>
                <div className="sl-divider" />
                <p className="sl-desc">{slide.desc}</p>
                <Link to={slide.cta.to} className="sl-btn">{slide.cta.label}</Link>
            </div>

            {/* Prev / Next arrows */}
            <button className="sl-arrow sl-arrow--prev" onClick={function() { goTo((current - 1 + slides.length) % slides.length); }} aria-label="Previous">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6" />
                </svg>
            </button>
            <button className="sl-arrow sl-arrow--next" onClick={function() { goTo((current + 1) % slides.length); }} aria-label="Next">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6" />
                </svg>
            </button>

            {/* Dots + progress */}
            <div className="sl-dots">
                {slides.map(function(_, i) { return (
                    <button
                        key={i}
                        className={`sl-dot${i === current ? ' sl-dot--active' : ''}`}
                        onClick={function() { goTo(i); }}
                        aria-label={`Slide ${i + 1}`}
                    >
                        {i === current && <span className="sl-dot-fill" key={animKey} />}
                    </button>
                ); })}
            </div>

        </header>
    );
}
